import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Όροι Χρήσης Nalumer | Κανονισμοί Υπηρεσίας Catering</title>
        <meta name="description" content="Οι όροι και προϋποθέσεις του Nalumer περιγράφουν τους κανόνες χρήσης του ιστότοπου και των υπηρεσιών catering, κρατήσεις, πληρωμές και υποχρεώσεις πελατών." />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Όροι και Προϋποθέσεις Χρήσης</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Γενικά</h2>
          <p>
            Καλώς ήρθατε στο Nalumer. Αυτοί οι όροι και προϋποθέσεις περιγράφουν τους κανόνες και 
            τις προϋποθέσεις για τη χρήση του ιστότοπου και των υπηρεσιών catering της Nalumer. 
            Με την πρόσβαση σε αυτόν τον ιστότοπο, θεωρούμε ότι αποδέχεστε αυτούς τους όρους και 
            προϋποθέσεις. Μην συνεχίσετε να χρησιμοποιείτε το Nalumer εάν δεν συμφωνείτε να 
            λάβετε όλους τους όρους και τις προϋποθέσεις που αναφέρονται σε αυτήν τη σελίδα.
          </p>
        </section>

        <section>
          <h2>2. Ορισμοί</h2>
          <ul>
            <li><strong>"Εταιρεία"</strong> αναφέρεται στο Nalumer</li>
            <li><strong>"Πελάτης", "Εσείς", "Χρήστης"</strong> αναφέρεται στο άτομο που χρησιμοποιεί τον ιστότοπο</li>
            <li><strong>"Υπηρεσίες"</strong> αναφέρεται στις υπηρεσίες catering που παρέχονται</li>
            <li><strong>"Ιστότοπος"</strong> αναφέρεται στο nalumer.com</li>
            <li><strong>"Παραγγελία"</strong> αναφέρεται σε οποιαδήποτε αίτηση για υπηρεσίες catering</li>
          </ul>
        </section>

        <section>
          <h2>3. Χρήση του Ιστότοπου</h2>
          <p>Με τη χρήση του ιστότοπού μας, συμφωνείτε:</p>
          <ul>
            <li>Να παρέχετε ακριβείς, ενημερωμένες και πλήρεις πληροφορίες κατά την παραγγελία</li>
            <li>Να διατηρείτε την ασφάλεια του κωδικού πρόσβασής σας</li>
            <li>Να μας ειδοποιείτε αμέσως για οποιαδήποτε μη εξουσιοδοτημένη χρήση του λογαριασμού σας</li>
            <li>Να μην χρησιμοποιείτε τον ιστότοπο για παράνομους σκοπούς</li>
            <li>Να μην παραβιάζετε νόμους στη δικαιοδοσία σας</li>
            <li>Να μην μεταδίδετε ιούς ή κακόβουλο κώδικα</li>
          </ul>
        </section>

        <section>
          <h2>4. Παραγγελίες και Πληρωμές</h2>
          <h3>4.1 Διαδικασία Παραγγελίας</h3>
          <p>
            Για να πραγματοποιήσετε μια παραγγελία, πρέπει να επιλέξετε τα προϊόντα ή τις υπηρεσίες 
            που επιθυμείτε, να συμπληρώσετε τη φόρμα παραγγελίας και να υποβάλετε την παραγγελία σας. 
            Θα λάβετε email επιβεβαίωσης με τις λεπτομέρειες της παραγγελίας σας.
          </p>
          
          <h3>4.2 Τιμές</h3>
          <p>
            Όλες οι τιμές εμφανίζονται σε Ευρώ (€) και περιλαμβάνουν ΦΠΑ, εκτός εάν αναφέρεται 
            διαφορετικά. Διατηρούμε το δικαίωμα να αλλάξουμε τις τιμές ανά πάσα στιγμή, αλλά οι 
            αλλαγές δεν θα επηρεάσουν τις παραγγελίες για τις οποίες έχουμε ήδη στείλει επιβεβαίωση.
          </p>
          
          <h3>4.3 Τρόποι Πληρωμής</h3>
          <p>Αποδεχόμαστε τις ακόλουθες μεθόδους πληρωμής:</p>
          <ul>
            <li>Πιστωτικές/Χρεωστικές κάρτες (Visa, Mastercard, American Express)</li>
            <li>PayPal</li>
            <li>Τραπεζική μεταφορά</li>
            <li>Αντικαταβολή (για επιλεγμένες περιοχές)</li>
          </ul>
          
          <h3>4.4 Επιβεβαίωση Παραγγελίας</h3>
          <p>
            Η παραγγελία σας θεωρείται επιβεβαιωμένη όταν λάβετε email επιβεβαίωσης από εμάς. 
            Διατηρούμε το δικαίωμα να αρνηθούμε ή να ακυρώσουμε οποιαδήποτε παραγγελία για 
            οποιονδήποτε λόγο.
          </p>
        </section>

        <section>
          <h2>5. Παράδοση και Εκτέλεση</h2>
          <h3>5.1 Περιοχές Παράδοσης</h3>
          <p>
            Παρέχουμε υπηρεσίες catering στην Αττική και σε επιλεγμένες περιοχές της Ελλάδας. 
            Οι χρόνοι παράδοσης και οι χρεώσεις ποικίλλουν ανάλογα με την τοποθεσία.
          </p>
          
          <h3>5.2 Χρόνοι Παράδοσης</h3>
          <p>
            Οι εκτιμώμενοι χρόνοι παράδοσης παρέχονται κατά την παραγγελία. Καταβάλλουμε κάθε 
            δυνατή προσπάθεια να παραδώσουμε στην ώρα που έχει συμφωνηθεί, αλλά δεν ευθυνόμαστε 
            για καθυστερήσεις λόγω ανωτέρας βίας.
          </p>
          
          <h3>5.3 Ακύρωση από την Εταιρεία</h3>
          <p>
            Διατηρούμε το δικαίωμα να ακυρώσουμε μια παραγγελία σε περιπτώσεις όπως:
          </p>
          <ul>
            <li>Μη διαθεσιμότητα προϊόντων</li>
            <li>Ανακριβείς πληροφορίες παραγγελίας</li>
            <li>Αδυναμία επικοινωνίας με τον πελάτη</li>
            <li>Ύποψη για δόλια δραστηριότητα</li>
          </ul>
        </section>

        <section>
          <h2>6. Ακυρώσεις και Τροποποιήσεις</h2>
          <h3>6.1 Ακύρωση από τον Πελάτη</h3>
          <p>
            Μπορείτε να ακυρώσετε ή να τροποποιήσετε την παραγγελία σας σύμφωνα με την Πολιτική 
            Επιστροφών μας. Οι όροι ακύρωσης εξαρτώνται από το χρόνο που απομένει μέχρι την 
            ημερομηνία παράδοσης:
          </p>
          <ul>
            <li>Πάνω από 72 ώρες: Πλήρης επιστροφή χρημάτων</li>
            <li>48-72 ώρες: Επιστροφή 50%</li>
            <li>Λιγότερο από 48 ώρες: Χωρίς επιστροφή χρημάτων</li>
          </ul>
          
          <h3>6.2 Τροποποιήσεις</h3>
          <p>
            Οι τροποποιήσεις στην παραγγελία είναι δυνατές μέχρι 48 ώρες πριν από την ημερομηνία 
            παράδοσης. Επικοινωνήστε μαζί μας το συντομότερο δυνατό για αλλαγές.
          </p>
        </section>

        <section>
          <h2>7. Ευθύνη και Εγγυήσεις</h2>
          <h3>7.1 Ποιότητα Προϊόντων</h3>
          <p>
            Εγγυόμαστε ότι όλα τα τρόφιμα παρασκευάζονται σύμφωνα με τα υψηλότερα πρότυπα υγιεινής 
            και ασφάλειας τροφίμων. Χρησιμοποιούμε φρέσκα, ποιοτικά υλικά.
          </p>
          
          <h3>7.2 Περιορισμός Ευθύνης</h3>
          <p>
            Η Nalumer δεν ευθύνεται για:
          </p>
          <ul>
            <li>Αλλεργικές αντιδράσεις - παρακαλούμε ενημερώστε μας για οποιεσδήποτε αλλεργίες</li>
            <li>Καθυστερήσεις λόγω ανωτέρας βίας</li>
            <li>Έμμεσες ή επακόλουθες ζημίες</li>
            <li>Απώλεια κερδών ή ευκαιριών</li>
          </ul>
          
          <h3>7.3 Αλλεργίες και Διατροφικές Απαιτήσεις</h3>
          <p>
            Είναι ευθύνη του πελάτη να μας ενημερώσει για τυχόν αλλεργίες ή διατροφικές απαιτήσεις 
            κατά την παραγγελία. Θα καταβάλουμε κάθε προσπάθεια να ικανοποιήσουμε τις ανάγκες σας.
          </p>
        </section>

        <section>
          <h2>8. Πνευματική Ιδιοκτησία</h2>
          <p>
            Όλο το περιεχόμενο του ιστότοπου, συμπεριλαμβανομένων κειμένων, γραφικών, λογότυπων, 
            εικόνων, φωτογραφιών και λογισμικού, είναι ιδιοκτησία της Nalumer και προστατεύεται 
            από νόμους περί πνευματικής ιδιοκτησίας. Απαγορεύεται η αναπαραγωγή χωρίς άδεια.
          </p>
        </section>

        <section>
          <h2>9. Προστασία Δεδομένων</h2>
          <p>
            Η χρήση των προσωπικών σας δεδομένων διέπεται από την Πολιτική Απορρήτου μας. 
            Με τη χρήση του ιστότοπου, συναινείτε στην επεξεργασία των δεδομένων σύμφωνα με 
            την πολιτική αυτή και τον ΓΚΠΔ.
          </p>
        </section>

        <section>
          <h2>10. Παράπονα και Διαφορές</h2>
          <h3>10.1 Διαδικασία Παραπόνων</h3>
          <p>
            Εάν έχετε οποιοδήποτε παράπονο σχετικά με τις υπηρεσίες μας, παρακαλούμε επικοινωνήστε 
            μαζί μας εντός 24 ωρών από την παράδοση:
          </p>
          <ul>
            <li>Email: <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></li>
            <li>Τηλέφωνο: +30 210 1234567</li>
          </ul>
          
          <h3>10.2 Επίλυση Διαφορών</h3>
          <p>
            Θα προσπαθήσουμε να επιλύσουμε όλες τις διαφορές φιλικά. Εάν δεν μπορούμε να 
            καταλήξουμε σε συμφωνία, οι διαφορές θα επιλύονται σύμφωνα με το ελληνικό δίκαιο.
          </p>
        </section>

        <section>
          <h2>11. Εφαρμοστέο Δίκαιο</h2>
          <p>
            Αυτοί οι όροι διέπονται και ερμηνεύονται σύμφωνα με τους νόμους της Ελλάδας. 
            Οποιαδήποτε διαφορά προκύψει σχετικά με αυτούς τους όρους θα υπόκειται στην 
            αποκλειστική δικαιοδοσία των δικαστηρίων της Αθήνας.
          </p>
        </section>

        <section>
          <h2>12. Τροποποίηση Όρων</h2>
          <p>
            Διατηρούμε το δικαίωμα να τροποποιούμε αυτούς τους όρους ανά πάσα στιγμή. 
            Οι τροποποιήσεις τίθενται σε ισχύ αμέσως μετά τη δημοσίευσή τους στον ιστότοπο. 
            Η συνεχής χρήση του ιστότοπου μετά από τροποποιήσεις συνιστά αποδοχή των νέων όρων.
          </p>
        </section>

        <section>
          <h2>13. Διαχωρισιμότητα</h2>
          <p>
            Εάν οποιαδήποτε διάταξη αυτών των όρων κριθεί άκυρη ή μη εφαρμόσιμη, η εν λόγω 
            διάταξη θα διαγραφεί και οι υπόλοιπες διατάξεις θα παραμείνουν σε πλήρη ισχύ.
          </p>
        </section>

        <section>
          <h2>14. Ολόκληρη Συμφωνία</h2>
          <p>
            Αυτοί οι όροι αποτελούν την πλήρη συμφωνία μεταξύ της Nalumer και του χρήστη 
            σχετικά με τη χρήση του ιστότοπου και αντικαθιστούν όλες τις προηγούμενες 
            συμφωνίες και κατανοήσεις.
          </p>
        </section>

        <section>
          <h2>15. Επικοινωνία</h2>
          <p>
            Για οποιεσδήποτε ερωτήσεις σχετικά με αυτούς τους όρους και προϋποθέσεις, 
            παρακαλούμε επικοινωνήστε μαζί μας:
          </p>
          <ul>
            <li>Email: <a href="mailto:nalumer@hotmail.com">nalumer@hotmail.com</a></li>
            <li>Τηλέφωνο: +30 210 1234567</li>
            <li>Διεύθυνση: Αθήνα, Ελλάδα</li>
            <li>Ώρες λειτουργίας: Δευτέρα - Παρασκευή, 9:00 - 18:00</li>
          </ul>
        </section>
      </div>
    </div>
  
    </>);
};

export default TermsConditions;